import { useState } from "react";
export function useBillingDetails(initialValues) {
    const [billingDetails, setBillingDetails] = useState(initialValues);
    const [editMode, setEditMode] = useState({
        organizationName: false,
        billingEmail: false,
        contactName: false,
    });
    const handleEdit = (field) => {
        const currentValue = billingDetails[field];
        const hasValue = currentValue.trim().length > 0;
        const isCurrentlyEditing = editMode[field];
        if (isCurrentlyEditing && hasValue) {
            // Save and disable editing
            setEditMode((prev) => ({
                ...prev,
                [field]: false,
            }));
            // TODO: Save to backend
        }
        else {
            // Enable editing
            setEditMode((prev) => ({
                ...prev,
                [field]: true,
            }));
        }
    };
    const handleChange = (field, value) => {
        setBillingDetails((prev) => ({
            ...prev,
            [field]: value,
        }));
    };
    const handleBlur = (field) => {
        setEditMode((prev) => ({
            ...prev,
            [field]: false,
        }));
        // TODO: Save to backend
    };
    return {
        billingDetails,
        editMode,
        handleEdit,
        handleChange,
        handleBlur,
    };
}
